/**
 * Converts a string with title and subtitle format into an object with title, subtitle, and value properties
 * @param {string} str - The input string to convert
 * @param {boolean} isEntityType - Whether to process the string as an entity type
 * @returns {Object|string} - Returns an object with title, subtitle, and value if processed, or the original string if not
 */
export const toEntityTitleSubtitle = (str, isEntityType) => {
  if (typeof str === "string" && isEntityType) {
    // Check if the string contains a newline character
    if (str.includes("(")) {
      const idx1 = str.lastIndexOf("(");
      const idx2 = str.lastIndexOf(")");
      const title = str.substring(0, idx1).trim();
      const subtitle = str.substring(idx1 + 1, idx2).trim();
      return {
        title: title,
        subtitle: subtitle,
        value: str,
      };
    }
  }
  return str;
};

export const toEntityTitle = (str, isEntityType) => {
  const result = toEntityTitleSubtitle(str, isEntityType);
  if (typeof result === "object") {
    return result.title;
  }
  return result;
};
